import axios from 'axios';
// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}


export default {
    currency() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/currency/cbo");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get(`proctender/detail/${obj.idTender}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    detailStep1(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get(`proctender/detailstep1/${obj.idTender}`);
                console.log(data);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    detailStep2(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get(`proctender/detailstep2/${obj.idTender}`);
                console.log(data);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    detailStep3(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get(`proctender/detailstep3/${obj.idTender}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    detailStep4(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get(`proctender/detailstep4/${obj.idTender}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    itemnosupplier(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get(`proctender/itemnosupplier/${obj.idTender}`);
                resolve(data[0]);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    requestdetail(obj){
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get(`proctender/requestdetail/${obj.requestkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });

    },
    exportxls(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['DimColInfo', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2','status', 'statusnm', 'statuswf', 'nomor', 'vendor', 'requestno', 'postgroup', 'item', 'status'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                const response = await axios({
                    url:`/proctender/exportxls${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                });
                resolve(response);
            } catch (error) {
                let responseObj = await error.response.data.text();
                errorHandler(JSON.parse(responseObj), reject);
            }
        });    
    },
    saveStep1of4(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                var result = await axios.post("proctender/saveStep1of4",obj);
                resolve(result);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    saveStep2of4(data) {
        return new Promise(async (resolve, reject) => {
            try {
                var result = await axios.post("proctender/saveStep2of4", data);
                console.log('saveStep2of4 result',result)
                resolve(result);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    saveQuotationStep3of4(data) {
        return new Promise(async (resolve, reject) => {
            try {
                var result = await axios.post("proctender/saveQuotationStep3of4", data);
                resolve(result);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    tenderStep3VendorDetail(obj){
        console.log('tenderStep3VendorDetail obj',obj)
        return new Promise(async (resolve, reject) => {
            try {
                var {data} = await axios.get(`proctender/detailstep3Vendor?idTender=${obj.idTender}&idTenderVendor=${obj.idTenderVendor}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    saveStep4of4(data) {
        return new Promise(async (resolve, reject) => {
            try {
                var result = await axios.post("proctender/saveStep4of4", data);
                resolve(result);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    list(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2','status', 'statusnm', 'statuswf', 'nomor', 'vendor', 'requestno', 'postgroup', 'item', 'status'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/proctender${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    paymterms() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/procure/paymterms");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    pasalpph() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/apinv/pasalpph");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    postgroup() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/procure/postgroup");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    getStatusList() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/proctender/getStatusList");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    approval(formData) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post("proctender/send2wf", formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    approvalUndo(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.put(`/proctender/send2wfCancel/${obj.idTender}`);
                resolve();
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    generatepo(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {data} = await axios.put(`/proctender/generatepo/${obj.idTender}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    // printTendering(obj = {}){
    //     console.log('obj ==>',obj)
    //     return new Promise(async (resolve, reject) => {
    //         try {
    //             if(obj.idTender){

    //             }else{
    //                 const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2','status', 'statuswf', 'nomor', 'vendor', 'requestno', 'postgroup', 'item', 'status'];
    //                 let str = '';
    //                 for (const key in obj) {
    //                     if (keys.indexOf(key) >= 0 && obj[key]) {
    //                         str += str ? '&' : '?';
    //                         str += key + '=' + encodeURIComponent(obj[key]);
    //                     }
    //                 }
    //                 console.log('str',str)
    //                 const url = `/proctender/printTendering/${str}`;
    //                 const { data } = await axios.get(url);
    //                 const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
    //                 resolve(link);
    //             }
                
    //         } catch (error) {
    //             errorHandler(error, reject);
    //         }
    //     });
    // },
    // printRfqStep2({idTender}) {
    //     return new Promise(async (resolve, reject) => {
    //         let url;
    //         let str = '';
    //         try {
    //             str = '?idTender=' + encodeURIComponent(idTender);
    //             url = `/proctender/printRfqStep2`;

    //             url += str;
    //             const { data } = await axios.get(url);
    //             const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
    //             resolve(link);
    //         } catch (error) {
    //             errorHandler(error, reject)
    //         }
    //     });
    // },
    emailRfq(obj = {}) {
        return new Promise(async (resolve, reject) => {
            let url;
            let str = '';
            try {
                str = '?idTenderVendor=' + encodeURIComponent(obj.idTenderVendor);
                url = `/proctender/emailrfq`;

                url += str;
                await axios.get(url);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    emailRfqCheck(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/proctender/emailrfqcheck/${obj.idVendor}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    printRfq(obj = {}) {
        return new Promise(async (resolve, reject) => {
            let url;
            let str = '';
            try {
                str = '?idTenderVendor=' + encodeURIComponent(obj.idTenderVendor);
                url = `/proctender/printrfq`;

                url += str;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    printBestSupplier(obj = {}) {
        return new Promise(async (resolve, reject) => {
            let url;
            let str = '';
            try {
                str = '?idTender=' + encodeURIComponent(obj.idTender);
                url = `/proctender/printBestSupplier`;

                url += str;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    receivingdoc() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/procure/receivingdoc");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.delete(`proctender/${obj.idTender}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    updateStep(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.delete(`proctender/${obj.idTender}/${obj.step}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    }
};